import { isValidDate } from "@/common/utils/dateValidator";
import { formatDate } from "@/common/utils/formatters";

export const dateTransformer = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

export const dateIsoTransformer = (isoDate: string): string => {
  const [datePart] = isoDate.split(' ');
  return dateTransformer(datePart);
};

export const dateTimeTransformer = (date: Date) => {
  if (!isValidDate(date)) return '';

  const formattedDate = formatDate(date);
  const formattedMinutes = String(date.getMinutes()).padStart(2, '0');

  return `${formattedDate} - ${date.getHours()}:${formattedMinutes}`;
};

export const dateToISOStingTransformer = (date: Date | undefined) => {
  return date ? `${date.toISOString().split("T")[0]}` : "";
}

export const dateBrStringToISO = (date: string | null | undefined) => {
  if (!date) return null;

  const [day, month, year] = date.split('/');

  if (!day || !month || !year) {
    return null;
  }

  return `${year}-${month}-${day}`;
};
